import { Text } from "@oysterhr/ui"
import { useTranslation } from "react-i18next"
import { HOW_TO_SET_UP_DIRECT_DEBIT_LINK } from "../../../utils"

export const HowToSetupDDParagraph = () => {
  const { t } = useTranslation("company_interface/CompanyPaymentMethodsPage/AchBankDetailsPearl")

  return (
    <Text className="mt-4">
      <Text as="span">{t("bankDetails.forMoreInformation")}</Text>
      <a href={HOW_TO_SET_UP_DIRECT_DEBIT_LINK} target="_blank" className="underline">
        {t("bankDetails.linkText")}
      </a>
    </Text>
  )
}
